import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api.model';
import { IDashboardData, IDeliveryNoteStats, IDeliveryNoteTimeline } from '../models/statistics.model';

@Injectable({
  providedIn: 'root',
})
export class StatisticService {
  private apiUrl = `${environment.apiUrl}/statistic`;

  constructor(private http: HttpClient) {}

  getDashboardData(): Observable<ApiResponse<IDashboardData>> {
    return this.http.get<ApiResponse<IDashboardData>>(`${this.apiUrl}/dashboard`);
  }

  getDeliveryNoteStats(from: Date, to: Date): Observable<ApiResponse<IDeliveryNoteStats>> {
    const params = new HttpParams().set('from', from.toISOString()).set('to', to.toISOString());
    return this.http.get<ApiResponse<IDeliveryNoteStats>>(`${this.apiUrl}/delivery-notes`, { params });
  }

  getDeliveryNoteTimeline(from: Date, to: Date): Observable<ApiResponse<IDeliveryNoteTimeline>> {
    const params = new HttpParams().set('from', from.toISOString()).set('to', to.toISOString());
    return this.http.get<ApiResponse<IDeliveryNoteTimeline>>(`${this.apiUrl}/delivery-notes/timeseries`, { params });
  }
}
